// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTimer as RawLucideTimer } from "lucide-react";
export const LucideTimer = /* @__PURE__ */ createIcon(RawLucideTimer, "LucideTimer", 2);
